import { render, staticRenderFns } from "./ResultItem.vue?vue&type=template&id=796402bb&scoped=true"
import script from "./ResultItem.vue?vue&type=script&lang=js"
export * from "./ResultItem.vue?vue&type=script&lang=js"
import style0 from "./ResultItem.vue?vue&type=style&index=0&id=796402bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796402bb",
  null
  
)

export default component.exports